import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { VehicleManager } from './vehicle-manager.model';
import { Observable, of } from 'rxjs';
export class VehicleManagerDataSource extends DataSource<VehicleManager> {
    data: Array<VehicleManager>;
    connect(): Observable<VehicleManager[]> {

        return of(this.data);
    }
    disconnect(collectionViewer: CollectionViewer): void {

    }
    setData(data: Array<VehicleManager>) {
        this.data = data;
    }

}
